import { request } from "../core/request";
import { OPERATION_IDS, DEFAULT_CONNECTION_FROM } from "../constants";

/**
 * User Details Response
 */
export interface UserDetailsResponse {
  statusCode: number;
  message: string;
  data: {
    mobileNo: string;
    name?: string;
    email?: string;
    [key: string]: unknown;
  };
}

/**
 * Customer Relationship Response
 */
export interface CustomerRelationshipResponse {
  statusCode: number;
  message: string;
  relationships: Array<{
    relationshipId: string;
    relationshipType: string;
    [key: string]: unknown;
  }>;
}

/**
 * Get customer relationship details
 *
 * @param mobileNo - User's mobile number
 * @returns Promise with relationship data
 */
export async function getCustomerRelationships(
  mobileNo: string
): Promise<CustomerRelationshipResponse> {
  return request<CustomerRelationshipResponse>({
    operationId: OPERATION_IDS.customerRelations,
    requestData: {
      mobileNo,
    },
    connectionFrom: DEFAULT_CONNECTION_FROM,
  });
}

/**
 * Get loan rewards information
 *
 * @param mobileNo - User's mobile number
 * @returns Promise with rewards data
 */
export async function getLoanRewards(mobileNo: string): Promise<unknown> {
  return request({
    operationId: OPERATION_IDS.loanRewards,
    requestData: {
      mobileNo,
    },
    connectionFrom: DEFAULT_CONNECTION_FROM,
  });
}

/**
 * Get callback request
 *
 * @param mobileNo - User's mobile number
 * @param productType - Product type for callback
 * @returns Promise with callback response
 */
export async function getCallback(mobileNo: string, productType: string): Promise<unknown> {
  return request({
    operationId: OPERATION_IDS.getACallBack,
    requestData: {
      mobileNo,
      productType,
    },
    connectionFrom: DEFAULT_CONNECTION_FROM,
  });
}

/**
 * Get hash code by mobile number
 *
 * @param mobileNo - User's mobile number
 * @returns Promise with hash code
 */
export async function getHashCode(mobileNo: string): Promise<unknown> {
  return request({
    operationId: OPERATION_IDS.getHashCode,
    requestData: {
      mobileNo,
    },
    connectionFrom: DEFAULT_CONNECTION_FROM,
  });
}
